import { createSelector } from '@reduxjs/toolkit'

const getLocationApi = (state: any) => state.locationApi

export const locationApiSelector = createSelector(getLocationApi, (locationApi) => locationApi)
